var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9975 9.16667C12.9975 7.55583 11.6916 6.25 10.0808 6.25C8.46998 6.25 7.16414 7.55583 7.16414 9.16667C7.16414 10.7775 8.46998 12.0833 10.0808 12.0833C11.6916 12.0833 12.9975 10.7775 12.9975 9.16667Z",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9831 9.45825C13.2514 9.53958 13.536 9.58333 13.8308 9.58333C15.4416 9.58333 16.7475 8.2775 16.7475 6.66667C16.7475 5.05583 15.4416 3.75 13.8308 3.75C12.3184 3.75 11.0748 4.90117 10.9286 6.37511",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23306 6.37511C9.08681 4.90117 7.84324 3.75 6.33081 3.75C4.71998 3.75 3.41414 5.05583 3.41414 6.66667C3.41414 8.2775 4.71998 9.58333 6.33081 9.58333C6.62565 9.58333 6.91027 9.53958 7.17853 9.45825",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 13.7502C18.4141 11.449 16.3621 9.5835 13.8308 9.5835",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 16.2502C14.6641 13.949 12.6121 12.0835 10.0808 12.0835C7.5495 12.0835 5.49748 13.949 5.49748 16.2502",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33081 9.5835C3.7995 9.5835 1.74748 11.449 1.74748 13.7502",
    stroke: "#2A2E34",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/users-icon.ecdd60bb222ff542feb34817ca8fe75a.svg";
export { ForwardRef as ReactComponent };